/*
 * A map of destination codes to their imported image assets.
 */
export const destinationImages: { [key: string]: () => Promise<string> } = {
  action: () =>
    import('@/assets/imgs/destinations/action.jpeg?width=128&height=128').then(
      (m) => m.default,
    ),
  chorvatsko: () =>
    import(
      '@/assets/imgs/destinations/chorvatsko.png?width=128&height=128'
    ).then((m) => m.default),
  'north-europe': () =>
    import(
      '@/assets/imgs/destinations/north-europe.jpg?width=128&height=128'
    ).then((m) => m.default),
  'positioning-emirates': () =>
    import(
      '@/assets/imgs/destinations/positioning-emirates.jpg?width=128&height=128'
    ).then((m) => m.default),
  recko: () =>
    import('@/assets/imgs/destinations/recko.png?width=128&height=128').then(
      (m) => m.default,
    ),
  'south-america': () =>
    import(
      '@/assets/imgs/destinations/south-america.jpg?width=128&height=128'
    ).then((m) => m.default),
  'canary-islands': () =>
    import(
      '@/assets/imgs/destinations/canary-islands.jpg?width=128&height=128'
    ).then((m) => m.default),
  mediterranean: () =>
    import(
      '@/assets/imgs/destinations/mediterranean.jpg?width=128&height=128'
    ).then((m) => m.default),
  'pacific-asia': () =>
    import(
      '@/assets/imgs/destinations/pacific-asia.jpg?width=128&height=128'
    ).then((m) => m.default),
  positioning: () =>
    import(
      '@/assets/imgs/destinations/positioning.jpg?width=128&height=128'
    ).then((m) => m.default),
  'round-world': () =>
    import(
      '@/assets/imgs/destinations/round-world.jpg?width=128&height=128'
    ).then((m) => m.default),
  transatlantic: () =>
    import(
      '@/assets/imgs/destinations/transatlantic.jpg?width=128&height=128'
    ).then((m) => m.default),
  caribbean: () =>
    import(
      '@/assets/imgs/destinations/caribbean.jpg?width=128&height=128'
    ).then((m) => m.default),
  'north-america': () =>
    import(
      '@/assets/imgs/destinations/north-america.jpg?width=128&height=128'
    ).then((m) => m.default),
  'persian-gulf': () =>
    import(
      '@/assets/imgs/destinations/persian-gulf.jpg?width=128&height=128'
    ).then((m) => m.default),
  'positioning-northern-europe': () =>
    import(
      '@/assets/imgs/destinations/positioning-northern-europe.jpg?width=128&height=128'
    ).then((m) => m.default),
  'south-africa': () =>
    import(
      '@/assets/imgs/destinations/south-africa.jpg?width=128&height=128'
    ).then((m) => m.default),
};
